import type { FrontendWidget } from '../types';
import { CompactPricingComponent } from './CompactPricingComponent';
import { CompactPricingComponentB } from './CompactPricingComponentB';
import { CompactPricingComponentC } from './CompactPricingComponentC';
import type { CompactPricingConfig, CompactPricingResolved } from './types';

export const compactPricingWidget: FrontendWidget<
  CompactPricingConfig,
  CompactPricingResolved
> = {
  componentType: 'widgets.compact-pricing',
  displayName: 'Compact Pricing',
  ComponentA: CompactPricingComponent,
  ComponentB: CompactPricingComponentB,
  ComponentC: CompactPricingComponentC,
  // No `resolveSync` — a lookup widget since SH-344 item 8. The cards never
  // render on a franchise Standort, whose prices are the partner's own and not
  // the central ones these cards resolve; only the backend knows the business
  // type. `CompactPricingResolver` passes the CMS cards through byte-for-byte
  // for every other page and every GmbH Standort.
};
